export default {
  status: [
    { name: 'Making', value: 0 },
    { name: 'Normal', value: 1 },
    { name: 'Private', value: 2 },
  ],
};
